'use strict';

/* button-wave.js — drives the .btn-wave hover origin point.
   Pairs with assets/button-wave.css. Sets --btn-wave-x/-y to wherever
   the pointer entered (and left) the button so the CSS clip-path
   circle grows from that exact spot instead of always the center. */
(function () {
  function setPoint(btn, evt) {
    var rect = btn.getBoundingClientRect();
    if (!rect.width || !rect.height) return;
    var x = ((evt.clientX - rect.left) / rect.width) * 100;
    var y = ((evt.clientY - rect.top) / rect.height) * 100;
    btn.style.setProperty('--btn-wave-x', x + '%');
    btn.style.setProperty('--btn-wave-y', y + '%');
  }

  function init(btn) {
    if (btn.dataset.waveInited) return;
    btn.dataset.waveInited = '1';

    btn.addEventListener('pointerenter', function (e) {
      if (e.pointerType === 'touch') return;
      setPoint(btn, e);
      btn.classList.add('is-active');
    });

    btn.addEventListener('pointermove', function (e) {
      if (e.pointerType === 'touch') return;
      if (!btn.classList.contains('is-active')) setPoint(btn, e);
    });

    btn.addEventListener('pointerleave', function (e) {
      if (e.pointerType === 'touch') return;
      setPoint(btn, e);
      btn.classList.remove('is-active');
    });

    btn.addEventListener('pointerdown', function (e) {
      setPoint(btn, e);
      btn.classList.add('is-active');
    });

    // Touch has no real "pointerleave" after a tap — the class was
    // getting stuck on (white text on a white/light background, or
    // invisible on dark) until the visitor happened to tap elsewhere.
    // Clear it shortly after the tap completes, or immediately if the
    // gesture is cancelled (e.g. a scroll took over).
    btn.addEventListener('pointerup', function (e) {
      if (e.pointerType !== 'touch') return;
      setTimeout(function () { btn.classList.remove('is-active'); }, 220);
    });
    btn.addEventListener('pointercancel', function () {
      btn.classList.remove('is-active');
    });
  }

  function initAll(root) {
    (root || document).querySelectorAll('.btn-wave').forEach(init);
  }

  // Toggles the async-loading look (label fades, a small ring spins in its
  // place) — for add-to-cart and other fetch-driven buttons. Creates the
  // spinner element on first use rather than requiring every template to
  // hand-author one.
  function setLoading(btn, isLoading) {
    if (!btn) return;
    if (isLoading) {
      if (!btn.querySelector('.btn-wave__spinner')) {
        var spinner = document.createElement('span');
        spinner.className = 'btn-wave__spinner';
        spinner.setAttribute('aria-hidden', 'true');
        btn.appendChild(spinner);
      }
      btn.classList.add('is-loading');
      btn.setAttribute('aria-busy', 'true');
    } else {
      btn.classList.remove('is-loading');
      btn.removeAttribute('aria-busy');
    }
  }

  document.addEventListener('DOMContentLoaded', function () { initAll(); });

  // The cart drawer (and cart page) re-render their whole footer markup on
  // every quantity change — fresh, uninitialised .btn-wave nodes each time
  // (see the same pattern in gift.js) — so re-scan on every cart update
  // rather than only once at page load.
  if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
    subscribe(PUB_SUB_EVENTS.cartUpdate, function () { initAll(); });
  }

  // Exposed so any JS that injects new .btn-wave markup later (wizard
  // steps, AJAX-rendered sections, etc.) can wire it up on demand.
  window.BabucoWaveButton = { init: init, initAll: initAll, setLoading: setLoading };
})();
